/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FanRemixContestStartedNotificationActionData
 */
export interface FanRemixContestStartedNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestStartedNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestStartedNotificationActionData
     */
    entityId: string;
}

/**
 * Check if a given object implements the FanRemixContestStartedNotificationActionData interface.
 */
export function instanceOfFanRemixContestStartedNotificationActionData(value: object): value is FanRemixContestStartedNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;

    return isInstance;
}

export function FanRemixContestStartedNotificationActionDataFromJSON(json: any): FanRemixContestStartedNotificationActionData {
    return FanRemixContestStartedNotificationActionDataFromJSONTyped(json, false);
}

export function FanRemixContestStartedNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestStartedNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityUserId': json['entity_user_id'],
        'entityId': json['entity_id'],
    };
}

export function FanRemixContestStartedNotificationActionDataToJSON(value?: FanRemixContestStartedNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_user_id': value.entityUserId,
        'entity_id': value.entityId,
    };
}

